// @flow
import React from "react";
import { connect } from "react-redux";
import RolloutMessageBox from "./ArenaView/RolloutMessageBox";
import ArenaSubmissionMenu from "./ArenaView/ArenaSubmissionMenu";
import CombatantTeam from "./ArenaView/CombatantTeam";
import "./ArenaView/ArenaView.css";
import ArenaMenuBrain from "./ArenaView/SubmissionMenu/ArenaMenuBrain.js";
import { getCombatantIdFromSelectingString } from "./get-combatant-id-from-selecting-string";
import ArenaTransitionOverlay from "./ArenaView/ArenaTransitionOverlay";
import ArenaBackgroundStyle from "./ArenaView/ArenaBackgroundStyle";
import AudioControl from "../_audio/AudioControl.js";
import ArneaEnvironmentBackground from "./ArenaView/ArenaEnvironmentBackground";
import TauntButton from "./ArenaView/TauntButton";
import TauntTextbox from "./ArenaView/TauntTextbox";
import ArenaMainLaptopContainer from "./ArenaMainLaptopContainer";
import DesktopSelectingCombatantTab from './DesktopSelectingCombatantTab'

class ArenaView extends React.Component {
  //Get a map of which row is the Pwlayer's team.
  // Enemy team should always be on Top row
  // Player team should always be on the Bottom row.
  getTeamOrientation(): Object {
    if (!this.props.battlePlayerIds.length) {
      //Handle the case where no battlePlayerIds are defined. (all bots)
      return {
        //Just roll with something
        topTeam: "two",
        bottomTeam: "one"
      };
    }
    const playerTeam = this.props.combatants[this.props.battlePlayerIds[0]]
      .belongsToTeam;
    return {
      topTeam: playerTeam === "one" ? "two" : "one",
      bottomTeam: playerTeam === "one" ? "one" : "two"
    };
  }

  //Return true if the currently selecting string is me (or you know, one of the me's in my battlePlayerIds array)
  isMenuOpen(): boolean {
    const { combatantSelectingAction, battlePlayerIds } = this.props;
    const useCombId = getCombatantIdFromSelectingString(
      combatantSelectingAction
    );

    if (combatantSelectingAction.match(/^cloudQueueAction::/)) {
      return false;
    }

    return battlePlayerIds.includes(useCombId);
  }

  render() {
    const { arenaAnimationComponent, viewportHeight } = this.props;

    const style = {
      position: "relative",
      height: viewportHeight
    };

    //Get the top row vs bottom row combatants
    const teamOrientation = this.getTeamOrientation();

    return (
      <div className="ArenaView" style={style}>
        {/* Graphic of the arena map */}
        <ArneaEnvironmentBackground />

        {/* Adjustable component for Attack animation (Troll, Focus overlays, etc) */}
        <ArenaBackgroundStyle />

        {this.isMenuOpen() &&
        this.props.arenaSubmissionMenuCombatantIdLock &&
        !this.props.arenaSubmissionIsSubmitted
          ? <ArenaMenuBrain />
          : null}

        {/* ENEMY TEAM (two) */}
        <CombatantTeam
          isEnemyTeam={true}
          combatantIds={this.props.teams[teamOrientation.topTeam].combatantIds}
        />

        {/* FRIENDLY TEAM (one) */}
        <CombatantTeam
          isEnemyTeam={false}
          combatantIds={
            this.props.teams[teamOrientation.bottomTeam].combatantIds
          }
        />

        <DesktopSelectingCombatantTab />
        {/* THESE THINGS ARE WRAPPED IN A LAPTOP */}
        <ArenaMainLaptopContainer>
          <RolloutMessageBox />
          <ArenaSubmissionMenu />
          
          <TauntButton />
        </ArenaMainLaptopContainer>


        <TauntTextbox />

        {/* Potentially mount an Animation Component */}
        {arenaAnimationComponent || null}

        {/* For Fading in and out of battle */}
        <ArenaTransitionOverlay />

        {/*TODO: This might need to move after b5 demo ;)*/}
        <AudioControl />
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    combatants: state.battle.combatants,
    teams: state.battle.teams,
    vW: state.global.vW,
    viewportHeight: state.global.viewportHeight,
    //someProp: state.something.someProp,

    arenaAnimationComponent: state.battle.arenaAnimationComponent,

    combatantSelectingAction: state.battle.combatantSelectingAction,
    battlePlayerIds: state.battle.battlePlayerId, //The array of player controlled combatantIds

    //Lock the ArenaBrain from mounting again until this flag has a value. It gets nulled out after usage.
    arenaSubmissionMenuCombatantIdLock:
      state.battle.arenaSubmissionMenuCombatantIdLock,

    arenaSubmissionIsSubmitted: state.battle.arenaSubmissionIsSubmitted //final flag
  };
})(ArenaView);



// WEBPACK FOOTER //
// ./src/battle/ArenaView.js